import React, { forwardRef } from "react";
import clsx from "clsx";

export const SceneHeader = forwardRef(
  (
    {
      icon,
      svg,
      iconRef,
      textRef,
      iconWrapperRef,
      className,
      children,
      ...props
    },
    ref
  ) => {

    return (
      <div
        {...props}
        ref={ref}
        role="alert"
        className={clsx(
          "card card-custom gutter-b mb-4",
          className
        )}
      >
        <div className="card-body px-5 py-4" ref={textRef}>
            {children}
        </div>
      </div>
    );
  }
);

// Set display name for debugging.
if (process.env.NODE_ENV !== "production") {
  SceneHeader.displayName = "SceneHeader";
}
